import React from 'react';
import { useTranslation } from 'react-i18next';

import moment from 'moment/moment';
import { JBSection } from '@bjb-gcrm/gcrm-frontend-components';
import { PartnerStatusDto } from 'views/RevisionHistory/Partner/PartnerRevisionDtos';
import { Employee } from 'types/Partner';
import { PartnerRevisionHistoryDetailTable } from 'views/RevisionHistory/Partner/PartnerRevisionHistoryDetailTable';
import { DlmLightRowType, isLatestChangesDlmLightRow } from 'views/DraftMode/DraftSwitch';

interface PartnerRevisionHistoryRowProps {
  techId: string;
  partnerStatusDtos: PartnerStatusDto[];
  version: number;
  employees: Employee[];
  dlmLightRowType: DlmLightRowType;
}

const NON_BREAKING_SPACE = '\u00A0';

export function PartnerRevisionHistoryRow({
  version,
  techId,
  partnerStatusDtos,
  employees,
  dlmLightRowType,
}: PartnerRevisionHistoryRowProps) {
  const { t } = useTranslation();
  const index = partnerStatusDtos.findIndex((status) => status.version === version);
  const history = partnerStatusDtos[index];
  const modifiedDate = moment(history.activatedAt ?? history.createdTimestamp).format('DD.MM.YYYY HH:mm');
  const isLatestChanges = isLatestChangesDlmLightRow(dlmLightRowType);
  const userId = history.activatedBy ?? history.modifiedBy;
  const employee = isLatestChanges
    ? 'not-needed'
    : (employees.find((employee) => employee.userId === userId)?.fullName ?? userId);
  const title = isLatestChanges
    ? t('revisionHistory.table.unsubmittedChanges')
    : modifiedDate + NON_BREAKING_SPACE.repeat(4) + t('revisionHistory.table.submittedBy') + ' ' + employee;
  const dataTestIdPostfix = isLatestChanges ? '-latest' : '';

  return (
    <JBSection
      title={title}
      customId={'change-section-version-' + version + dataTestIdPostfix}
      useDivider={true}
      narrowMargins={true}
      defaultExpanded={false}
      infoText={isLatestChanges ? t('revisionHistory.table.unsubmittedChangesInfo') : undefined}
      titleTypographyVariant="h6"
    >
      <PartnerRevisionHistoryDetailTable
        techId={techId}
        index={index}
        partnerStatusDtos={partnerStatusDtos}
        dlmLightRowType={dlmLightRowType}
      />
    </JBSection>
  );
}
